
import { Component, namespace, Vue } from 'nuxt-property-decorator'

import BPSection from './snippets/BPSection.vue'
import BPSectionHeader from './snippets/BPSectionHeader.vue'

import clientsWithFeedbackList from '~/components/sections/clients-feedback/feedback.json'
import { IFeedbackUser } from '~/components/sections/clients-feedback/types'
import { CommonState, namespace as commonStore } from '~/store/modules/Common'

import ClientsFeedbackList from '~/components/sections/clients-feedback/ClientsFeedbackList.vue'

const CommonStore = namespace(commonStore)

const maxCurrentListItems = 9

@Component({
  components: {
    BPSection,
    BPSectionHeader,
    ClientsFeedbackList,
  },
})
export default class BPClientsFeedback extends Vue {
  @CommonStore.State('totalOrders')
  readonly totalOrders!: CommonState['totalOrders']

  clients: IFeedbackUser[] = []

  fetch () {
    this.clients = clientsWithFeedbackList
      .sort(() => Math.random() - 0.5)
      .slice(0, maxCurrentListItems)
  }
}
